<forge-label-value>
    <span slot="label">{{label}}</span>
    <span slot="value">
        <ng-content></ng-content>
    </span>
</forge-label-value>